/**
 * CrudApp.jsx
 * Root component. useCrudApi is called ONCE here — it owns the fetch loop.
 * All mutation handlers flow down as props so no child needs to call the hook.
 */

import { CrudProvider } from "./context/CrudContext";
import useCrudApi from "./hooks/useCrudApi";
import Header from "./components/Header";
import Controls from "./components/Controls";
import CrudTable from "./components/CrudTable";

function CrudAppInner() {
    const {
        handleToggleStatus,
        handleDuplicate,
        handleTrash,
        handleRestore,
        handlePermanentDelete,
        handleBulkTrash,
        handleBulkRestore,
        handleBulkPermanentDelete,
        handleBulkStatus,
    } = useCrudApi();

    return (
        <div className="mx-auto p-3 sm:p-6 bg-gray-50 min-h-screen">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <Header />
                <Controls
                    onBulkTrash={handleBulkTrash}
                    onBulkRestore={handleBulkRestore}
                    onBulkPermanentDelete={handleBulkPermanentDelete}
                    onBulkStatus={handleBulkStatus}
                />
                <CrudTable
                    onToggleStatus={handleToggleStatus}
                    onDuplicate={handleDuplicate}
                    onTrash={handleTrash}
                    onRestore={handleRestore}
                    onPermanentDelete={handlePermanentDelete}
                />
            </div>
        </div>
    );
}

export default function CrudApp() {
    return (
        <CrudProvider>
            <CrudAppInner />
        </CrudProvider>
    );
}
